export default __webpack_public_path__ + "static/media/chatbot.6ab55cfa.png";